import { apiClient } from '@/shared/services/client'
import type {
  Fuente,
  FuenteCreateInput,
  FuenteUpdateInput,
} from '@/modules/bd-unificada/types/fuente'

const BASE = '/bd-unificada/fuentes'

export async function getFuentes(): Promise<Fuente[]> {
  const response = await apiClient.get<Fuente[]>(`${BASE}/`)
  return response.data
}

export async function getFuente(id: string): Promise<Fuente> {
  const response = await apiClient.get<Fuente>(`${BASE}/${id}`)
  return response.data
}

export async function createFuente(data: FuenteCreateInput): Promise<Fuente> {
  const response = await apiClient.post<Fuente>(`${BASE}/`, data)
  return response.data
}

export async function updateFuente(id: string, data: FuenteUpdateInput): Promise<Fuente> {
  const response = await apiClient.put<Fuente>(`${BASE}/${id}`, data)
  return response.data
}
